import { render, staticRenderFns } from "./LastLabReports.vue?vue&type=template&id=7847037b&scoped=true"
import script from "./LastLabReports.vue?vue&type=script&lang=js"
export * from "./LastLabReports.vue?vue&type=script&lang=js"
import style0 from "./LastLabReports.vue?vue&type=style&index=0&id=7847037b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847037b",
  null
  
)

export default component.exports